export default {
  computed: {
    pendingApproval() {
      return 1;
    },
    approved() {
      return 2;
    },
    rejected() {
      return 3;
    },
    cancelled() {
      return 4;
    },
  },
};
